export default __webpack_public_path__ + "3b8ba90b9696df3b858101370b98cc29.svg";